import { Component, Renderer2, ElementRef, OnInit, ViewEncapsulation, input, output, inject, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgClass } from '@angular/common';

import '@asn/icon';

/**
 *  @deprecated
 *  in favor of [`@asn/notification`](https://designsystem.acc.aws.devolksbank.net/index.html?path=/docs/web-components-notification--docs).
 *  To be removed with the Angular 23 migration.
 *
 * @module ApNotificationModule
 *
 * @ngdoc component
 * @name ApNotificationComponent
 *
 * @param {string} status
 *
 * @description
 *
 */
@Component({
    selector: 'ap-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [NgClass],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ApNotificationComponent implements OnInit {
    private readonly renderer = inject(Renderer2);
    private el = inject(ElementRef);

    /**
     * Status of notification.
     * Possible values: `tip` | `warning` | `error` | `info` | `success`.
     * Default is `info`
     */
    public readonly status = input<'tip' | 'warning' | 'error' | 'info' | 'success'>('info');

    /**
     * Is notification closeable?
     * Defaults to false
     */
    public readonly closeable = input(false);

    /**
     * Is it the last notification in a list of notifications?
     * Has effect on styling
     * Defaults to false
     */
    public readonly last = input(false);

    /**
     * Emits when close notification is clicked.
     */
    public readonly closeClicked = output<void>();

    public ngOnInit(): void {
        this.setRole();
    }

    protected setRole() {
        if (this.status() === 'error') {
            this.renderer.setAttribute(this.el.nativeElement, 'role', 'alert');
        } else {
            this.renderer.setAttribute(this.el.nativeElement, 'role', 'status');
        }
    }

    protected getIconName() {
        if (this.status() === 'success') {
            return 'checkmark';
        }
        if (this.status() === 'tip') {
            return 'lightbulb';
        }
        if (this.status() === 'error' || this.status() === 'warning') {
            return 'exclamation-triangle';
        }
        return null;
    }

    protected showIcon(): boolean {
        return this.status() !== 'info';
    }

    protected emitClosed(): void {
        this.closeClicked.emit();
    }
}
